/**
 * Delays execution for a specified number of milliseconds.
 *
 * @param {number} ms - The number of milliseconds to delay.
 * @returns {Promise<void>} - A Promise that resolves after the delay.
 */
export const delay = (ms: number) => new Promise((resolve) => setTimeout(resolve, ms));

/**
 * Checks if a variable is a promise (has a 'then' method).
 *
 * @param {any} promise - The variable to check.
 * @returns {boolean} - True if the variable is a promise, otherwise false.
 */
export const isPromise = (promise) => !!promise && typeof promise.then === 'function';
